import { http } from './request'

/** loginMenu 返回的菜单节点（字段兼容 Snowy 常见结构） */
export interface ApiMenuItem {
  id: string
  parentId?: string
  title?: string
  name?: string
  icon?: string
  path?: string
  menuType?: string
  visible?: string
  sortCode?: number
  children?: ApiMenuItem[]
}

function asRecord(v: unknown): Record<string, unknown> | null {
  return v && typeof v === 'object' ? (v as Record<string, unknown>) : null
}

function pickStr(o: Record<string, unknown>, key: string): string | undefined {
  const v = o[key]
  if (v == null) return undefined
  const s = String(v).trim()
  return s || undefined
}

/** Hutool Tree 把 SYS_RESOURCE 放 extra；title 也可能在 meta.title */
function pickNodeField(o: Record<string, unknown>, key: string): string | undefined {
  const extra = asRecord(o.extra)
  const meta = asRecord(o.meta) ?? (extra ? asRecord(extra.meta) : null)
  return (
    pickStr(o, key) ??
    (extra ? pickStr(extra, key) : undefined) ??
    (meta ? pickStr(meta, key) : undefined)
  )
}

function normalizeNode(raw: unknown): ApiMenuItem | null {
  const o = asRecord(raw)
  if (!o) return null
  const id = o.id != null ? String(o.id) : ''
  if (!id) return null
  const childrenRaw = o.children
  const children = Array.isArray(childrenRaw)
    ? childrenRaw.map((x) => normalizeNode(x)).filter((x): x is ApiMenuItem => x != null)
    : undefined
  const title = pickNodeField(o, 'title')
  const name = pickNodeField(o, 'name')
  return {
    id,
    parentId: pickNodeField(o, 'parentId'),
    title,
    name,
    icon: pickNodeField(o, 'icon'),
    path: pickNodeField(o, 'path'),
    menuType: pickNodeField(o, 'menuType') ?? pickNodeField(o, 'type'),
    visible: pickNodeField(o, 'visible'),
    sortCode:
      typeof o.sortCode === 'number' ? o.sortCode : Number(pickNodeField(o, 'sortCode') ?? NaN),
    children,
  }
}

/** 获取当前登录用户可见菜单（仅平台管理目录树） */
export async function fetchLoginMenus(): Promise<ApiMenuItem[]> {
  const raw = await http.get<unknown>('/biz/overseas/sysuser/loginMenu')
  if (!Array.isArray(raw)) return []
  return raw.map((x) => normalizeNode(x)).filter((x): x is ApiMenuItem => x != null)
}
